import React from 'react';

import LandingLayout from '../layouts/landing.layout';

import Home from '../pages/home.page';
import Contact from '../pages/contact.page';
import LatestJob from 'pages/latest-job.page';

export const landingRoutes = [
  {
    path: '/',
    element: <LandingLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'latest-jobs', element: <LatestJob /> },
      { path: 'contact', element: <Contact /> },
    ],
  },
];
